<span class="badge rounded-pill badge-sm" [ngClass]="badgeClasses">
  {{text}}
</span>
